import { IconCheck } from "@tabler/icons-react";
import { Text } from "../../../../components/common/typography";

const STEPS = ["Delivery details", "Payment", "Confirmation"] as const;

interface CheckoutStepperProps {
  current: 1 | 2 | 3;
}

export function CheckoutStepper({ current }: CheckoutStepperProps) {
  return (
    <div className="grid grid-cols-3">
      {STEPS.map((label, i) => {
        const step = i + 1;
        const isActive = step === current;
        const isDone = step < current;

        return (
          <div
            key={label}
            className={`flex items-center justify-center gap-2 pb-3 border-b-2 ${
              isActive || isDone ? "border-textDark" : "border-borderDefault"
            }`}
          >
            <div
              className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors ${
                isActive || isDone ? "bg-textDark text-bgWhite" : "bg-bgDisabled text-textMuted"
              }`}
            >
              {isDone
                ? <IconCheck size={16} className="text-bgWhite" />
                : <Text variant="bodySmBold" tone="inherit" inline>{step}</Text>}
            </div>
            <Text variant="bodySm" tone="dark" inline>
              {label}
            </Text>
          </div>
        );
      })}
    </div>
  );
}
